// Despacho.styles
import styled from "styled-components";
import { gray80 } from "@carbon/colors";
import { g100 } from '@carbon/themes';

export const SideBySideContainer = styled.div`
  display: grid;
  grid-auto-rows: minmax(0, auto);
  gap: 0.2rem;
`;

/* one row = two cells (ida | vuelta) */
export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.2rem;
  align-items: stretch;   /* both cells same row height */
`;

export const Column = styled.div`
  min-width: 0;           /* avoid overflow with inner scrollers */
  display: flex;
`;

export const Cell = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  /* make RouteRow fill the cell */
  & > * { height: 100%; }
`;

export const RouteSummary = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 13px;
  color: #6f6f6f;
  gap: 12px;
  background: ${gray80};
  padding: 6px 10rem;          /* left-right spacing for balance */
  margin-top: 0;              /* remove gap from above */
  margin-bottom: 0.5rem;      /* small spacing between rows */
  min-height: 34px;           /* makes it taller and consistent */
  letter-spacing: 0.3px;
  border-top: 1px solid #393939; /* subtle divider */

  span:last-child {
    color: #24a148;
    margin-left: 8px;
    font-weight: 600;
  }
`;

export const IframeDespacho = styled.iframe`
  height: 60vh;
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  width: 100%;
`;

export const CustomTag = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  height: 24px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
  background-color: ${props => props.$color || '#525252'};
  color: #ffffff;
`;

export const TagsRowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px;
  align-items: center;
`;

export const FlexWrapContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${props => props.$gap || '8px'};
  width: 100%;
  border: 1px solid ${g100.borderSubtle01};
  padding: 16px;
`;

export const SectionTitle = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  color: ${g100.textPrimary};
  margin-bottom: 4px;
`;